var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Folate",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 109,
    height: 112,
    viewBox: "0 0 109 112",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2195",
    "data-name": "Rectangle 2195",
    width: 49.77,
    height: 62.873,
    transform: "translate(0 0)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(-0.135 0.024)",
    opacity: 0.151
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Icon.BG",
    cx: 54.5,
    cy: 56,
    rx: 54.5,
    ry: 56,
    transform: "translate(0.135 -0.024)",
    fill: "#85b765"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4692",
    "data-name": "Group 4692",
    transform: "translate(29.615 24.618)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4532",
    "data-name": "Group 4532",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12151",
    "data-name": "Path 12151",
    d: "M16.9,11.715C15.3,9.336,12.25.037,5.9,1.8,2.3,2.808.477,9.069,2.3,15.288c1.429,4.894,4.747,9.042,3.332,10.56S2.96,30.319,5.9,32.371s9.8,3.936,16.405,5.264c0,0,3.4-10.5,2.272-13.921s-6.073-9.621-7.677-12",
    fill: "#508034"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12152",
    "data-name": "Path 12152",
    d: "M19.776,13.016c-.642-.881-1.194-1.637-1.563-2.185-.247-.367-.584-1.028-.972-1.792C15.521,5.658,12.643,0,7.463,0A7.411,7.411,0,0,0,5.475.28,6.6,6.6,0,0,0,1.553,3.634C-.191,6.771-.489,11.406.775,15.731a37.744,37.744,0,0,0,2.232,5.512,13.934,13.934,0,0,1,1.384,3.609,6.611,6.611,0,0,0-1.834,4.975,5.309,5.309,0,0,0,2.436,3.842c3.669,2.562,12.225,4.558,17,5.519l1.384.278.434-1.343c.6-1.834,3.5-11.179,2.269-14.906-.944-2.851-4.041-7.1-6.3-10.2m1.442,22.779C14.21,34.307,9,32.6,6.806,31.074a2.25,2.25,0,0,1-1.1-1.582,3.648,3.648,0,0,1,1.08-2.565c1.592-1.71.431-4.176-.914-7.033a35.116,35.116,0,0,1-2.057-5.051c-1.02-3.488-.821-7.284.506-9.671a3.653,3.653,0,0,1,2-1.843,4.291,4.291,0,0,1,1.139-.163c3.238,0,5.476,4.4,6.956,7.309A22.339,22.339,0,0,0,15.587,12.6c.386.573.962,1.363,1.631,2.28,2.018,2.768,5.067,6.95,5.855,9.331.6,1.812-.625,7.444-1.855,11.584",
    fill: "#30662c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12153",
    "data-name": "Path 12153",
    d: "M42.674,9.335c-4.3,2.283-8.371,10.367-9.952,12.782,0,0-2.036-2.147-2.717,1.549s-.032,13.1-.258,15.841a118.394,118.394,0,0,1,10.929-6.38c5.969-3.065,6.073-7.815,7.2-15.576s-.9-10.5-5.2-8.216",
    fill: "#508034"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12154",
    "data-name": "Path 12154",
    d: "M41.931,7.938C38.052,10,34.58,15.894,32.505,19.416q-.18.306-.345.584a2.732,2.732,0,0,0-.676-.087c-.895,0-2.481.451-3.036,3.468-.45,2.452-.361,6.907-.283,10.837.043,2.16.083,4.2,0,5.159L27.9,42.666l2.735-1.847A117.95,117.95,0,0,1,41.4,34.535c6.159-3.164,6.83-8.015,7.759-14.73.09-.651.183-1.326.285-2.024.681-4.661.3-7.749-1.161-9.439-1.405-1.626-3.675-1.823-6.351-.4m4.379,9.386c-.1.708-.2,1.39-.288,2.048-.886,6.406-1.374,9.935-6.069,12.348-3.535,1.815-6.579,3.621-8.581,4.864-.009-.747-.025-1.566-.042-2.429a69.3,69.3,0,0,1,.232-10.2,5.221,5.221,0,0,1,.145-.606l1.242,1.31,1.1-1.673c.309-.47.711-1.151,1.188-1.961,1.78-3.021,5.093-8.646,8.183-10.288a4.1,4.1,0,0,1,1.828-.593.747.747,0,0,1,.643.271c.287.332,1.168,1.814.423,6.912",
    fill: "#30662c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12155",
    "data-name": "Path 12155",
    d: "M10.6,11.384a1.048,1.048,0,0,0-1.8,1.068c.163.276,16.3,27.68,16.085,41.613l0,7.76a1.048,1.048,0,1,0,2.095,0l0-7.742c.23-14.506-15.7-41.553-16.377-42.7",
    fill: "#85b765"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12156",
    "data-name": "Path 12156",
    d: "M9.974,26.564a1.047,1.047,0,1,0,.389,2.058c.064-.012,6.423-1.132,7.756,1.975a1.049,1.049,0,0,0,.963.634,1.024,1.024,0,0,0,.413-.086,1.047,1.047,0,0,0,.549-1.377c-2.013-4.685-9.743-3.266-10.07-3.2",
    fill: "#85b765"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12157",
    "data-name": "Path 12157",
    d: "M42.8,17.364a1.042,1.042,0,0,0-1.449.291C39.7,20.134,25.238,42.07,25.716,48.6l.149,13.236a1.051,1.051,0,0,0,1.047,1.037h.013a1.049,1.049,0,0,0,1.036-1.061l-.153-13.3c-.361-4.977,10.911-23.123,15.286-29.7a1.044,1.044,0,0,0-.292-1.452",
    fill: "#85b765"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolate);
export default __webpack_public_path__ + "static/media/Folate.26446400ae6d77000d363a11adc3a577.svg";
export { ForwardRef as ReactComponent };